export default __webpack_public_path__ + "static/media/React__2.c4c3f0b0.png";